export default {
    tip: 'tip',
    title: 'Background management system',
    logoutTip: 'Exit the system, do you want to continue?',
    submitText: 'submit',
    cancelText: 'cancel',
    search: 'Please input search content',
    menuTip: 'none menu list',
    wel: {


      project: 'Project access',
      count: 'Item number',

    },
    route: {
      info: 'info',
      website: 'website',
      avuexwebsite: 'avuex',
      dashboard: 'dashboard',
      more: 'more',
      tags: 'tags',
      store: 'store',
      api: 'api',
      logs: 'logs',
      table: 'table',
      form: 'form',
      top: 'backtop',
      data: 'data',
      permission: 'permission',
      error: 'error',
      test: 'test'
    },
    login: {
      title: 'Login',
      info: 'Background management system',
      tenantId: 'Please input tenantId',
      username: 'Please enter your account number or mobile phone password',
      password: 'Please enter your password',
      forpass:'Forgot password',
      phone: 'Mobile phone number Verification',
      code: 'Please enter the verification code',
      submit: 'Login',
      userLogin: 'userLogin',
      phoneLogin: 'phoneLogin',
      thirdLogin: 'thirdLogin',
      msgText: 'Send verification code',
      msgSuccess: 'reissued code',
    },
    navbar: {
      logOut: 'Log out',
      userinfo: 'userinfo',
      dashboard: 'dashboard',
      lock: 'lock',
      bug: 'none bug',
      bugs: 'bug',
      screenfullF: 'exit screenfull',
      screenfull: 'screenfull',
      language: 'language',
      notice: 'notice',
      theme: 'theme',
      color: 'Change the color',
      reset: 'Reset'
    },
    tagsView: {
      search: 'Search',
      menu: 'menu',
      clearCache: 'Clear cache',
      closeOthers: 'Close Others',
      closeAll: 'Close all'
    },
    // 实时页面
    realtimeinfo:{
      checkDev:"Select the project",
      search:"Search",
      roomNum:"Building no",
      eleNum:"Elevator model",
      offLine:'offline',
      onLine:"online",
      turnOff:"turn off",
      powerOn:"Start up",
      standard:"Standard",
      eleTem:"elevator car temperature"

    },
    realdetile:{
      filterAir:"Select air conditioners",
      eleInfo:'Air conditioning information',
      infoPara:"Information parameters",
      faultInfo:"Fault information",
      setPara:"Set parameters",
      water:"Water level indication",
      view:"Check",
      search:"search",
      operaStatus:"running state",
      opera:"Operation",
      return:"return",
      serNum:"Serial number",
      airconditionalNum:"Air conditioning sets",
      contUnit:"Unit of contact",
      projectStatus:"Project status",

      delayOff:"Delayed shutdown",
      modelDetail:"Mode Details",
      choAir:"Selection of air conditioning",
      pleInputAirCode:"Please enter the air conditioner number",
      timeModeView:"View timing mode information",
      eleTem:"Elevator car temperature",
      waterLevel:"Water level",
      suVoltage:"Supply voltage",
      totalCurrent:"Total current",
      coilTemp:"The coil temperature",
      windTem:"The wind temperature",
      heating:"Heating",
      refrigeration:"refrigeration",
      setwindSpeed:"Set wind speed",
      highWind: "High wind",
      wind:"blowing-in",
      lowWind:"Low wind",
      on:"Power on",
      off:"Power off",
      defrosting:"Defrost",
      highWindStatus:"High wind relay status",
      lowWindStatus:"Low wind relay status",
      waterPumpStatus:"Water pump relay status",
      heatStatus:"Heating relay status",
      paStatus:"Compression relay status",
      eleTemFail:"Elevator car temperature sensor fault",
      windTemFail:"Air outlet temperature sensor fault",
      coilTemFail:"Coil temperature sensor failure",
      airCho:"Screening of air conditioning",
     },
    //远程操作
    manipulation:{
      questTimedOut:"Request timeout, please operate again",
    executing:"Instruction execution in progress",
      sglOpera:"Single operation",
      bulkOpera:"Batch operation",
      select:"Select the project",
      devName:"Project name",
      buildNum:"Building no",
      ladderNum:"Elevator model",
      airModel:"Air conditioning type",
      installAddress:"Installation address",
      executionResult:"Instruction execution result",
      airModelSetting:"Set the operating mode of the air conditioner",
      airParameterSetting:"Air Conditioner Parameter Settings",
      manual:"Manual",
      timing:"Timing",
      unreported:"Not reported",
      sleepModeOff:"Sleep mode off",
      sleepModeOn:"Sleep mode on",
      sleepMode:"Sleep mode",
      manModeParSetting:"Manual mode parameter setting",
      timModeParSetting:"Set the timing mode parameter",
      manMode:"Manual mode",
      timMode:"timing mode",
      ParSetting:"Parameter setting",
      choice:"Selected air conditioning",
      benTimeSetting:"Baseline time setting",
      curHour:"Current time",
      currentWeek:"Current week",
      timingSetting:"Timing time setting",
      addTime:"Adding a Timer",
      timer:"The timer",
      timedOn:"Timing open",
      timedOff:"Timing off",
      model:"Model",
      temp:"Temperature",
      windSpeed:"Wind speed",
      week:"week",
      cancel:"cancel",
      sure:"Confirm",
      airNum:"Air conditioning number",
      elevatorBrand:"Elevator brand",
      deviceAdressNum:"Address of the device",
      comBoard:"IMEI code of the communication board",
      comStatus:"Communicate status",
      workStatus:"Working state",
      operaMode:"Operation mode",
      opeSec:"The command is executed successfully",
      opefau:"Failed to execute the command",

      pleChoiceAir:"Please select air conditioner first",
      opeSucc:"Operate successfully",
      exDifAir:"There is an air conditioner different from the current setting mode",
      sawBack:"Saw back pressure alarm history",
      insNum:"Installation sets",
      auto:"Automatic",
      wind:"ventilation",
      paSelect:"Parameter selection",
      temRange:"Temperature range",
      devStatus:"Equipment state",
      anyTime:"Any point in time",
      timeSet:"Timing time setting"

    },
    //历史数据
    dataAnalysis:{
      deviceInfo:"Equipment information",
      timeChs:"Time to choose",
      monitorchs:"Selection of monitoring points",
      inquire:"Query",
      reset:"Reset",
      chart:"Chart",
      form:"Form",
      time:"Time",
      prev:"Front page",
      next:"Next page",

      project:"Project",
      lift:"Elevator",
      endTime:"endTime",
      startTime:"startTime",
      pleCho:"Please select",
      unit:"unit",
      alFirstPage:"unit",
      alLastPage:"It's the last page",
      none:"Temporarily no data",
    },
    //操作日志
    sendCmdLog:{
      queryMethod:"Query mode",
      date:"Date",
      actContent:"Operating content",
      actResult:"Operating results",
      actPeople:"Operator",
      pleAddCode:"Please enter address code",
      arrive:"-",
      startDate:"Start date",
      endDate:"End date",
      addCodeQuery:"Query by address code",
      levelQuery:"Query by hierarchy",
      today:"Present day",
      lastWeek:"Last week",
      lastMonth:"Last month",
      success:"success",
      fault:"fault",
    },
    //报警设置
    alarmSetting:{
      airModelQuire:"Air Conditioner Model Query",
      addAlarm:"New alarm",
      alarmName:"Alarm name",
      alarmLevel:"Alarm level",
      assMonitor:"Associate monitoring points",
      alarmContent:"Alarm content",
      triggerCondition:"The trigger condition",
      alarmType:"Alarm type",
      alarmThreshold:"The alarm threshold",
      copMethodChoose:"How to cope (Optional)",
      webAlarm:"web System Alarms",
      alarmContacts:"Alarm contact person",
      assVariable:"Associated variables",
      alarm:"Alarm",
      delete:"Delete",
      edit:"Edit",
      prompt:"Tips",
      promptContent:"Are you sure you want to delete it?",

      inputAlarmName:"Please enter the alarm name",
      choAlarmType:"Please select the alarm type",
    choAssVariable:"Please select the associated variable",
      inputAlarmValue:"Please enter the alarm value",
      inputAlarmContent:"Please enter the alarm content",
      editAlarm:"Edit the alarm",
      addSuc:"Successfully added",
      addFauRepeat:"Failed to add the device. Please try again or check the help",
      chaSuc:"Modify the success",
      chaFauRepeat:"Modification failed, please try again later",
      fillComplete:"Please complete",
      deleteSuc:"Deleted successfully",
      deleteFau:"Delete failed",
      airCode:"Air conditioning number",
      statusList:"State list",
      number:"Quantity",
    },
    //报警数据
    alarmData:{
      monitorList:"List of monitoring points",
      dataName:"Data point name",
      curAlarmTime:"Current alarm time",
      dataValue:"The data values",
      status:"State",
      processTime:"The processing time",
      copMethod:"Response",

      processed:"Processed",
      notProcessed:"Untreated",
      lookHistory:"Click to view historical alarms",
      choiceDate:"Select a date",
      startDate:"Start date",
      endDate:"End date",
      fail:"The fault",
      numericValue:"The numerical",
      everyPage:"each page",
      strip:"条",
      currentPage:"Current Page",
      loading:"Loading",
    },
    //人员管理
    userManage:{
      account:"Mobile phone number",
      operatorName:"Operator name",
      operaPermission:"Operation authority",
      addUser:"New users",
      userName:"Role name",
      password:"password",
      phoneNum:"phone",
      roleName:"Character name",

      pleInputProName:"Please enter a project name",
      newAdd:"New add",
      assignItem:"Assigned project",
      ifActivation:"Active or not",
      addAccountName:"Please add a user name",
      addPassword:"Please add a password",
      addPhone:"Please add the mobile number",
      addRole:"Please assign roles",
      phoneFault:"The format of the mobile phone number is wrong",
      chaAccount:"Modify the user",
      passLess:"Password length shall be at least 6 digits",
      revisePer:"Modify the permissions",
      addRoleName:"Add a role name",
      addRoleDes:"Add a role description",
      addUpRole:"Add a higher role",
      addUpRole:"New role",
      reviseRole:"Modify the role",
    },
    roleManage:{
      roleDescription:"Role description",
      createTime:"Creation time",
      parentRole:"The superior role",
      revise:"Modify",

      updateSuc:"Update successfully",
      upDateFauRepeat:"Update failed, please try again"

    },

    fileManage:{
      areaName:"Area name",
      add:"add",
      timeSetting:"Installation time",
      province:"Province",
      city:"City",
      longitude:"Longitude",
      latitude:"Latitude",
      contact:"Contact",
      contactPhone:"Contact phone number",
      installer:"Installation personnel",
      map:"Pick a point on the map",
      keyWords:"Keyword search",
      infoback:"Are you sure to delete",

      pleChoArea:"Please select an area",
      lookHisRevise:"Viewing historical modification",
      viewDetail:"Check the details",
      handoff:"switch",
      insHisNameRevise:"Modify the historical name of the installation site",
      chaAccount:"Change the account",
      updateTime:"Update time",
      debug:"debugging",
      set:"Operation",
      inputLongitude:"Please enter the longitude",
      inputLatitude:"Please enter the latitude",
      inputCityName:"Please enter the city name",
      inputProvinceName:"Please enter the province name",

    },

    omcenter:{
      name:"name",
    address:"address",
    onlineDev:"Online equipment",
    offlineDev:"Offline equipment",
    devNum:"Total number of devices",
    hideDevName:"Hide Device Name",
    piece:"pc",
    showDevName:"Display equipment name",
    hideDevName:"Hide Device Name",
    inChina:"中国",
    devPlace:"Distribution of equipment"
    },

    parmodel:{
      theMonday:"Monday",
    theTuesday:"Tuesday",
    theWednesday:"Wednesday",
    theThursday:"Thursday",
    theFriday:"Friday",
    theSaturday:"Saturday",
    theSunday:"Sunday",
    temMoreRange:"Temperature out of range",
    necTimer:"Timer content is required",
    temRangeIs:"Temperature range is",
    noTemEmpty:"Temperature cannot be empty",
    pleTemRight:"Please check whether the temperature is input correctly",
    pointIssued:"The instructions have been issued.",
    mostAddTenPiece:"Add up to 10",
    leastOnePiece:"At least one",
    },

    stationModal:{
      assignmentDev:"Allocate equipment",
      devCode:"Equipment number",
      devModel:"Equipment model",
      devBh:'Equipment No',
      all:'all',
      setSuc:"Set up the success",
      setFauRepeat:"Setting failed"
    },

    fileInfo:{
      pleInputAirCode:"Please enter the air conditioner number",
      totalAirModel:"Air conditioning model statistics",
      import:"Import EXCEL",
      clickLoad:"Click the import",
      explain:"Note: The import file must be in excel format. You can click to download the template first.",
      downImport:"Download Template",
      boundBoard:"Binding communication board",
      totalAirModel:"Air conditioning model statistics",
      hangZhou:"杭州",
      place:"Site",
      pleSearchPlace:"Please enter the place to search",
      mapPoint:"Pick a point on the map",
      keySearch:"Keyword search",
      boundType:'Communication board type',
      devadress:'Device address',
      pleInputAirlh:'Please enter the air conditioning building number',
      pleInputAirth:'Please enter the air conditioning building number',
      pleInputAirxh:'Please enter the air conditioner model',
      pleInputAirpp:'Please enter the elevator brand',
    },
  }
